module.exports = __webpack_public_path__ + "img/2-2.03632c85.svg";